// File: MergersAcquisitions.jsx
import React from "react";

export default function MergersAcquisitions() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Mergers & Acquisitions
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks manages legal, financial, and regulatory M&amp;A processes.
          </p>
          <p className="text-gray-700">
            Complete M&amp;A transaction services including NCLT scheme approvals, merger filings (CAA-2), valuation reports, shareholder approvals, competition commission clearances, and post-merger compliance under Companies Act 2013.
          </p>
        </div>

        {/* Right: Image (M&amp;A SPECIFIC) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184432/pexels-photo-3184432.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Mergers and acquisitions services by Hawkins & Brooks"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation for seamless M&amp;A transactions.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Financial statements & audit reports</li>
                <li>Valuation reports (registered valuer)</li>
                <li>Regulatory approvals (NCLT, CCI)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Strategic transaction expertise ensuring successful M&amp;A completions.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Companies Act Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Companies Act 2013 Chapter XV knowledge including scheme of amalgamation (CAA-2), NCLT approvals, 90% shareholder/creditor consents, valuation compliance, swap ratio calculations, and merger accounting standards.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Regulatory Clearances
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise NCLT filings, CCI Form-I/II approvals, SEBI compliances (listed entities), sector-specific clearances (RBI/FEMA, IRDA), tax structuring (stamp duty, capital gains), and post-merger compliance ensuring transaction closure.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Strategic Transaction Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service M&amp;A from due diligence through term sheet negotiation, scheme drafting, NCLT representation, shareholder meetings, regulatory filings, closing documentation, post-merger integration, and compliance advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
